export const scrollTop = () => {
  const logo = document.querySelector('.doc-title a');
  window.scrollTo({ top: 0, behavior: 'smooth' });
  if (logo) logo.focus();
};
